import { gqlCountry, gqlCurrency } from '@minecraft.graphql-types';

/**
 * All currency codes are "valid" this simply returns the code if it's
 * something we actually want to display to the user (different from default
 * browser implementations)
 * https://castingnetworks.atlassian.net/browse/B21-28118
 *
 * @example:
 *  US country code + currency code USD = $102.99
 *  UK country code + currency code USD = $102.99 USD
 *  CAD country code + currency code USD = $102.99 USD
 *  MX country code + currency code USD = $102.99 USD
 */
export const getCurrencyCodeLabel = (currencyCode: gqlCurrency['code'], countryCode: gqlCountry['code']) => {
  const codesWithoutLabels = { GBP: true, EUR: true };

  // USD is special as we only don't show it if the countryCode is US
  if (currencyCode === 'USD' && countryCode === 'US') {
    return '';
  }

  // We need an additional space when it's added so when it's empty we don't have extra spaces
  return codesWithoutLabels[currencyCode] ? '' : `${currencyCode} `;
};
